var map = {
	"./404.svg": 16616,
	"./bug.svg": 92813,
	"./chart.svg": 13751,
	"./clipboard.svg": 96889,
	"./component.svg": 10250,
	"./dashboard.svg": 4679,
	"./documentation.svg": 23397,
	"./drag.svg": 28715,
	"./edit.svg": 95869,
	"./education.svg": 3937,
	"./email.svg": 39083,
	"./example.svg": 21649,
	"./excel.svg": 42474,
	"./exit-fullscreen.svg": 54861,
	"./eye-open.svg": 12429,
	"./eye.svg": 95628,
	"./filter.svg": 57175,
	"./form.svg": 3771,
	"./fullscreen.svg": 6638,
	"./guide.svg": 47987,
	"./icon.svg": 92814,
	"./international.svg": 5091,
	"./language.svg": 5247,
	"./link.svg": 81445,
	"./list.svg": 99161,
	"./lock.svg": 52636,
	"./message.svg": 38166,
	"./money.svg": 49659,
	"./nested.svg": 85016,
	"./password.svg": 39902,
	"./pdf.svg": 38001,
	"./people.svg": 34952,
	"./peoples.svg": 46779,
	"./qq.svg": 75951,
	"./search.svg": 58217,
	"./shopping.svg": 65697,
	"./size.svg": 88334,
	"./skill.svg": 92160,
	"./star.svg": 48637,
	"./tab.svg": 94598,
	"./table.svg": 54383,
	"./theme.svg": 88972,
	"./tree-table.svg": 41622,
	"./tree.svg": 92701,
	"./user.svg": 68848,
	"./wechat.svg": 80719,
	"./zip.svg": 71902
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71525;